var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Path, Svg, Text } from "react-native-svg";
var polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
    };
};
var describeDonutPath = function (x, y, radius, startAngle, endAngle, size, rx) {
    if (rx === void 0) { rx = 0; }
    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);
    var start2 = polarToCartesian(x, y, radius - size, endAngle);
    var end2 = polarToCartesian(x, y, radius - size, startAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    var cor = 10;
    var d = [
        "M", start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y,
        // "L", end2.x, end2.y,
        "A", rx, rx, 0, 0, 0, end2.x, end2.y,
        "A", radius - size, radius - size, 0, largeArcFlag, 1, start2.x, start2.y,
        "A", rx, rx, 0, 0, 0, start.x, start.y,
    ].join(" ");
    return d;
};
var Guide = function (props) {
    var viewBox = props.viewBox, frecuencyTable = props.frecuencyTable, showLabel = props.showLabel, showValue = props.showValue, _a = props.strokeWidth, strokeWidth = _a === void 0 ? 2 : _a, space = props.space, textColor = props.textColor;
    var _b = props.viewBox, width = _b.width, height = _b.height, x = _b.x, y = _b.y;
    var min = width > height ? height : width;
    var center = (min / 2);
    var radius = center - (strokeWidth / 2);
    var totl = radius / (frecuencyTable.intervals.length + 1);
    var sobrante = 4;
    return React.createElement(React.Fragment, null, new Array(props.frecuencyTable.parts + 1).fill(0).map(function (a, i) {
        var _a;
        // const xcenter = (i * (width / props.frecuencyTable.parts)) + x
        // const ycenter = (y + height) - (i * (height / props.frecuencyTable.parts))
        var pola = polarToCartesian(center + x, center + y, radius + sobrante, ((270 / props.frecuencyTable.parts) * (i)));
        var pola2 = polarToCartesian(center + x, center + y, totl - sobrante, ((270 / props.frecuencyTable.parts) * (i)));
        var polatext = polarToCartesian(center + x, center + y, radius + sobrante + 8, ((270 / props.frecuencyTable.parts) * (i)));
        return React.createElement(React.Fragment, null,
            React.createElement(Path, { key: "r" + i, strokeWidth: 1, stroke: "#666666", 
                // opacity={0.8}
                fill: "transparent", d: [
                    "M", pola2.x, pola2.y,
                    "L", pola.x, pola.y,
                ].join(" ") }),
            React.createElement(Text, { dx: polatext.x, dy: polatext.y, textAnchor: "middle", fill: (_a = props.textColor) !== null && _a !== void 0 ? _a : "#000", fontSize: 8, translateY: 4 }, props.frecuencyTable.range_min + (props.frecuencyTable.scale * i)));
    }));
};
export default (function (props) {
    var viewBox = props.viewBox, frecuencyTable = props.frecuencyTable, showLabel = props.showLabel, showValue = props.showValue, _a = props.strokeWidth, strokeWidth = _a === void 0 ? 2 : _a, space = props.space, textColor = props.textColor;
    var width = viewBox.width, height = viewBox.height, x = viewBox.x, y = viewBox.y;
    var newViewBox = { width: width, height: height, x: x, y: y };
    if (!props.showGuide && props.showLabel) {
        // newViewBox = { width: width, height: height - 38, x: 0, y: 4 }
    }
    var padding = 20;
    if (props.showGuide && !props.showLabel) {
        newViewBox = { width: width - (padding * 2), height: height - (padding * 2), x: x + (padding), y: y + (padding) };
    }
    if (props.showGuide && props.showLabel) {
        newViewBox = { width: width - (padding * 2), height: height - (padding * 2), x: x + (padding), y: y + (padding) };
    }
    var min = (newViewBox.width) > (newViewBox.height) ? (newViewBox.height) : (newViewBox.width);
    var center = min / 2;
    var radius = center - (strokeWidth / 2);
    var max = frecuencyTable.max("relative_frequency");
    var currentAngle = 0;
    var separacion = ((min / (frecuencyTable.intervals.length + 1)) * (space !== null && space !== void 0 ? space : 0)) + ((strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 0));
    // const grosor = radius / this.props.data.length
    var grosor = ((radius - (separacion * (frecuencyTable.intervals.length + 1))) / (frecuencyTable.intervals.length + 1));
    // const grosor = radius / (frecuencyTable.intervals.length + 1)
    // const scale = center - (strokeWidth / 2);
    // const radio = center * 0.5;
    var rx = 0.1;
    var Gra = frecuencyTable.relative_frequency.map(function (f, i) {
        var angle = 0;
        angle = ((f * 0.75) / max) * 360;
        var xi = (((i + 1) * (grosor + separacion)));
        var color = frecuencyTable.intervals_color[i];
        var p = React.createElement(Path, { key: "r" + i, strokeWidth: strokeWidth, fill: color + "99", stroke: color, 
            // stroke={"transparent"}
            // fill={"transparent"}
            d: describeDonutPath(center + newViewBox.x, center + newViewBox.y, grosor + xi + (separacion / 2), 0, angle, grosor, rx) });
        var pBack = React.createElement(Path, { d: describeDonutPath(center + newViewBox.x, center + newViewBox.y, grosor + xi + (separacion / 2), 0, 360 * 0.75, grosor, rx), fill: color, opacity: 0.2 });
        var start = polarToCartesian(center + newViewBox.x, center + newViewBox.y, (grosor / 2) + xi, 0);
        var end = polarToCartesian(center + newViewBox.x, center + newViewBox.y, (grosor / 2) + xi, angle);
        var end2 = polarToCartesian(center + newViewBox.x, center + newViewBox.y, (grosor / 2) + xi + separacion, angle);
        currentAngle += angle;
        var label;
        if (showLabel) {
            label = (React.createElement(Text, { dx: start.x - (grosor * 0.7), dy: start.y - (separacion / 2) + (grosor * 0.7 / 2), textAnchor: "end", fill: textColor !== null && textColor !== void 0 ? textColor : "#000", fontSize: grosor * 0.7 }, frecuencyTable.intervals[i]));
        }
        var value;
        if (showValue) {
            value = (React.createElement(Text, { dx: end2.x, dy: end2.y, textAnchor: "middle", fill: textColor !== null && textColor !== void 0 ? textColor : "#000", fontSize: grosor * 0.5 }, (frecuencyTable.frequency_data[i]).toFixed(1)));
        }
        return React.createElement(React.Fragment, null,
            pBack,
            p,
            label,
            value);
    });
    return React.createElement(Svg, { height: "100%", width: "100%", viewBox: "0 0 ".concat(width, " ").concat(height) },
        !props.showGuide ? null : React.createElement(Guide, __assign({}, props, { viewBox: newViewBox })),
        Gra);
});
